import { Component, OnInit } from '@angular/core';
import { UserService } from '../../core/services/user.service';
import { NavigationHelperService } from '../../core/services/navigation-helper.service';
import { FeatureFlagService } from '../../core/services/feature-flag/feature-flag.service';
import { Observable, of } from 'rxjs';
import { APP_FLAG_MAP } from '../../core/services/feature-flag/feature-flag.map';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
    public filteredApps$: Observable<any>;

    constructor(
        private userService: UserService,
        private navigationHelperService: NavigationHelperService,
        private featureFlagService: FeatureFlagService,
    ) {}

    ngOnInit(): void {
        this.userService.allowedApps$.subscribe(async (apps) => {
            const filteredEntries = await Promise.all(
                Object.entries(apps).map(async ([appName, appData]) => {
                    const flagName = APP_FLAG_MAP[appName];

                    if (!flagName) {
                        return null;
                    }

                    const isEnabled = await this.featureFlagService.isFeatureFlagEnabled(flagName);

                    return isEnabled ? [appName, appData] : null;
                }),
            );

            const filtered = filteredEntries.filter((entry): entry is [string, any] => !!entry);
            const filteredObj = Object.fromEntries(filtered);

            this.filteredApps$ = of(filteredObj);
        });
    }

    appClicked(appName: string) {
        this.navigationHelperService.appClicked(appName);
    }
}
